import { LoadableComponent } from '@hh.ru/loadable-component';

import AdminArticle from 'src/pages/AdminArticle';
import AdminArticlesCatalog from 'src/pages/AdminArticlesCatalog';
import AdminCollectionEdProgramsCatalogPage from 'src/pages/AdminCollectionEdProgramsCatalog';
import AdminCourse from 'src/pages/AdminCourse';
import AdminCoursesCatalog from 'src/pages/AdminCoursesCatalog';
import AdminEducation from 'src/pages/AdminEducation';
import AdminEducationsCatalog from 'src/pages/AdminEducationsCatalog';
import AdminProfession from 'src/pages/AdminProfession';
import AdminProfessionsCatalog from 'src/pages/AdminProfessionsCatalog';
import AdminPromotionsCatalog from 'src/pages/AdminPromotionsCatalog';
import AdminProvidersCatalog from 'src/pages/AdminProvidersCatalog';
import AdminProvidersStreamWeightPage from 'src/pages/AdminProvidersStreamWeight';
import AdminStorefronts from 'src/pages/AdminStorefronts';
import AdminStream from 'src/pages/AdminStream';
import AdminStreamsCatalog from 'src/pages/AdminStreamsCatalog';
import Article from 'src/pages/Article';
import ArticlesCatalog from 'src/pages/ArticlesCatalog';
import CertLanding from 'src/pages/CertLanding';
import CollectionEdProgram from 'src/pages/CollectionEdProgram';
import EdPrograms from 'src/pages/EdPrograms';
import Index from 'src/pages/Index';
import LK from 'src/pages/LK';
import Profession from 'src/pages/Profession';
import Professions from 'src/pages/Professions';
import Profile from 'src/pages/Profile';

import {
    ADMIN_COURSE_CREATE_ROUTE,
    ADMIN_COURSE_EDIT_ROUTE,
    ADMIN_COURSES_CATALOG_ROUTE,
    CERT_LANDING,
    ED_PROGRAMS_ROUTE,
    INDEX_ROUTE,
    PROFESSION_ROUTE,
    PROFESSIONS_ROUTE,
    LK_ROUTE,
    ADMIN_STREAMS_CATALOG_ROUTE,
    ADMIN_STREAM_EDIT_ROUTE,
    ADMIN_STREAM_CREATE_ROUTE,
    ADMIN_PROFESSIONS_CATALOG_ROUTE,
    ADMIN_PROFESSION_CREATE_ROUTE,
    ADMIN_PROFESSION_EDIT_ROUTE,
    PROFILE_ROUTE,
    ADMIN_PROVIDERS_CATALOG_ROUTE,
    ADMIN_PROMOTIONS_CATALOG_ROUTE,
    ADMIN_STOREFRONTS_ROUTE,
    ADMIN_EDUCATION_CREATE_ROUTE,
    ADMIN_EDUCATION_EDIT_ROUTE,
    ADMIN_EDUCATION_CATALOG_ROUTE,
    ADMIN_ARTICLE_CREATE_ROUTE,
    ADMIN_ARTICLE_EDIT_ROUTE,
    ADMIN_ARTICLES_CATALOG_ROUTE,
    COLLECTION_ED_PROGRAM_ROUTE,
    ADMIN_COLLECTION_ED_PROGRAMS_CATALOG_ROUTE,
    ARTICLE_ROUTE,
    ARTICLES_CATALOG_ROUTE,
    ADMIN_PROVIDERS_STREAM_WEIGHT,
} from 'src/app/routesUtils/urls';

type Routes = { path: string; component: LoadableComponent<object> }[];

const routes: Routes = [
    // PUBLIC
    {
        path: INDEX_ROUTE,
        component: Index,
    },
    {
        path: PROFESSION_ROUTE,
        component: Profession,
    },
    {
        path: PROFESSIONS_ROUTE,
        component: Professions,
    },
    {
        path: ED_PROGRAMS_ROUTE,
        component: EdPrograms,
    },
    {
        path: COLLECTION_ED_PROGRAM_ROUTE,
        component: CollectionEdProgram,
    },
    {
        path: LK_ROUTE,
        component: LK,
    },
    {
        path: PROFILE_ROUTE,
        component: Profile,
    },
    {
        path: ARTICLE_ROUTE,
        component: Article,
    },
    {
        path: ARTICLES_CATALOG_ROUTE,
        component: ArticlesCatalog,
    },
    // ASSESSMENT
    {
        path: CERT_LANDING,
        component: CertLanding,
    },
    // ADMIN
    {
        path: ADMIN_COURSES_CATALOG_ROUTE,
        component: AdminCoursesCatalog,
    },
    {
        path: ADMIN_COURSE_CREATE_ROUTE,
        component: AdminCourse,
    },
    {
        path: ADMIN_COURSE_EDIT_ROUTE,
        component: AdminCourse,
    },
    {
        path: ADMIN_EDUCATION_CATALOG_ROUTE,
        component: AdminEducationsCatalog,
    },
    {
        path: ADMIN_EDUCATION_CREATE_ROUTE,
        component: AdminEducation,
    },
    {
        path: ADMIN_EDUCATION_EDIT_ROUTE,
        component: AdminEducation,
    },
    {
        path: ADMIN_STREAMS_CATALOG_ROUTE,
        component: AdminStreamsCatalog,
    },
    {
        path: ADMIN_STREAM_EDIT_ROUTE,
        component: AdminStream,
    },
    {
        path: ADMIN_STREAM_CREATE_ROUTE,
        component: AdminStream,
    },
    {
        path: ADMIN_PROFESSIONS_CATALOG_ROUTE,
        component: AdminProfessionsCatalog,
    },
    {
        path: ADMIN_PROFESSION_CREATE_ROUTE,
        component: AdminProfession,
    },
    {
        path: ADMIN_PROFESSION_EDIT_ROUTE,
        component: AdminProfession,
    },
    {
        path: ADMIN_PROVIDERS_CATALOG_ROUTE,
        component: AdminProvidersCatalog,
    },
    {
        path: ADMIN_PROMOTIONS_CATALOG_ROUTE,
        component: AdminPromotionsCatalog,
    },
    {
        path: ADMIN_STOREFRONTS_ROUTE,
        component: AdminStorefronts,
    },
    {
        path: ADMIN_ARTICLES_CATALOG_ROUTE,
        component: AdminArticlesCatalog,
    },
    {
        path: ADMIN_ARTICLE_CREATE_ROUTE,
        component: AdminArticle,
    },
    {
        path: ADMIN_ARTICLE_EDIT_ROUTE,
        component: AdminArticle,
    },
    {
        path: ADMIN_COLLECTION_ED_PROGRAMS_CATALOG_ROUTE,
        component: AdminCollectionEdProgramsCatalogPage,
    },
    {
        path: ADMIN_PROVIDERS_STREAM_WEIGHT,
        component: AdminProvidersStreamWeightPage,
    },
];

export default routes;
